import * as styles from "./DrawerFooter.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DrawerFooterProps } from "./Drawer.types";

export function DrawerFooter({
  className,
  ...props
}: DrawerFooterProps): JSX.Element {
  return (
    <div
      data-slot="drawer-footer"
      className={clsx(styles.footer, className)}
      {...props}
    />
  );
}
